module.exports = __webpack_public_path__ + "static/media/heroBg.3a81be76.png";